import {FormGroupComponent, FormGroupCteComponent} from './form';
import {SelectFilterComponent} from './select/select-filter.component';

export const CUSTOM_ELEMENTS = [
    FormGroupComponent,
    FormGroupCteComponent,
    SelectFilterComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/elements/index.ts